import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";


export default function ProgramDetails({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings, onPageTitle, navbarObjectId, isMobile }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
    onPageTitle && onPageTitle(title);
  }, [pageTitle, title, onPageTitle]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  const [FilterHeightInvestmentProjects, setFilterHeight] = useState(688);

  useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [_col_id_investmentprojects]))").then(async (reply) => {
          const InvestmentProjectsNumberOfFilterRows = reply*27+40;
          console.log('InvestmentProjectsNumberOfFilterRows/Number of rows: ', InvestmentProjectsNumberOfFilterRows);
          setFilterHeight(InvestmentProjectsNumberOfFilterRows);
        }).catch(err => {
          if(!err) setError(err);
        });
      }, 500);
    });
  }, [app, err])

  return (
    <section className="content fillpage">
      <div className="content-header">
        <div className="mobile-page-header">
          <h4 className="mobile-page-title">{title}</h4>
          {navbarObjectId && isMobile && (
            <div className="mobile-page-object">
              <QlikObject
                key={`mobile-${navbarObjectId}`}
                id={navbarObjectId}
                height="30px"
                showLoader={false}
              />
            </div>
          )}
        </div>
      </div>

      <div className="container-fluid page-default fillpage-body">

        <div className="row justify-content-start fillpage-row">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 fillpage-col">

              {/* table fills the whole left column */}
              <div className="band-table">
                <QlikCard
                  id="be0cd1b1-b87a-428f-b9cc-bf3c5ab7f508"
                  height="100%"
                  showHeader={true}
                  showMaximize={true}
                  showExport={true}
                  onBeforeExportHandler={async ({  }) => {
                      await app.variable.setStringValue('export_link', '1');
                  }}
                  onAfterExportHandler={async ({  }) => {
                      app.variable.setStringValue('export_link', '0');
                  }}
                  exportText = {menuItemsStrings.exportText}
                  exportCompletedText = {menuItemsStrings.exportCompletedText}
                  closeBtnText = {menuItemsStrings.closeBtnText}
                  exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                  exportNoObjectText={menuItemsStrings.exportNoObjectText}
                  actionsVisibility="always"
                  copyCells="true"
                  copiedSuccessMessage={menuItemsStrings.copiedSuccessMessage}
                  copiedFailedMessage={menuItemsStrings.copiedFailedMessage}
                />
              </div>

            </div>


            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing fillpage-col">

                  {/* FilterPane — grows (0.6 share) */}
                  <div className="band-grow-60">
                    <QlikCard
                      id="e6b6f059-b920-469c-bd8e-27224864a66e"
                      height="100%"
                      showHeader={false}
                      showMaximize={false}
                      showExport={false}
                      showOverlayer={false}
                    />
                  </div>

                  {/* Selector — fixed */}
                  <div className="band-fixed">
                    <QlikObject
                      id="5feb099c-ecd0-4954-8d71-875cf08bad9a"
                      height="var(--selector-h)"
                      showHeader={false}
                      showMaximize={false}
                      showExport={false}
                      showOverlayer={false}
                    />
                  </div>

                  {/* Columns Selector — grows (0.4 share) */}
                  <div className="band-grow-40">
                    <QlikCard
                      id="bf0f0c4a-f8dd-4574-931f-d8cd71f806f5"
                      height="100%"
                      showHeader={false}
                      showMaximize={false}
                      showExport={false}
                      showOverlayer={false}
                    />
                  </div>

            </div>

          </div>

          {/* hidden export helper — outside the fill row */}
          <div className="row">
            <div className="col-md-2 col-sm-3 col-2">
              <QlikObject
                id="sZmBgv"
                height="0px"
                showLoader={false}
              />
            </div>
          </div>

        </div>
    </section>
  );
}